const listeners = new Set<() => void>();

let pending = false;

export function isVaultRecoverySetupPending(): boolean {
  return pending;
}

export function beginVaultRecoverySetup(): void {
  pending = true;
  notify();
}

export function completeVaultRecoverySetup(): void {
  pending = false;
  notify();
}

export function subscribeVaultRecoverySetup(listener: () => void): () => void {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

function notify(): void {
  listeners.forEach((listener) => listener());
}
